import React, { Component } from "react";

type Props = {
    children: React.ReactNode
 }
 

class ErrorBoundary extends Component<Props> {
    
    state = { hasError: false };
  
    static getDerivedStateFromError() {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  
    componentDidCatch(error: any, errorInfo: any) {
      // You can also log the error to an error reporting service
      console.log("errorBoundary")
      console.log(error, errorInfo);
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return <h1>Ocurrió un error.</h1>;
      }
  
      return this.props.children; 
    }
  }

  export default ErrorBoundary;